import { render, staticRenderFns } from "./project-planning.vue?vue&type=template&id=30260cc9"
import script from "./project-planning.vue?vue&type=script&lang=js"
export * from "./project-planning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports